export var EmissionFactorInclude = {
    locations: { where: { deleted: false } },
    products: { where: { deleted: false } },
    businessUnits: { where: { deleted: false } },
    territory: { include: { continent: true } },
    modeledImpact: true,
    denominatorUnit: true,
    supplier: true,
    activityDataSource: {
        include: {
            activityDataSourceTypes: true,
        },
    },
    unit: true,
    origin: true,
    children: {
        include: {
            unit: true,
            activityDataSource: true,
        },
    },
};
export var EmissionFactorIncludeFiltered = function (organizationId) { return ({
    locations: { where: { deleted: false } },
    products: { where: { deleted: false } },
    businessUnits: { where: { deleted: false } },
    territory: { include: { continent: true } },
    modeledImpact: true,
    denominatorUnit: true,
    supplier: true,
    activityDataSource: {
        include: {
            parent: true,
            activityDataSourceTypes: true,
        },
    },
    unit: true,
    origin: true,
    children: {
        where: {
            OR: [{ organizationId: organizationId }, { organizationId: null }],
        },
        include: {
            unit: true,
            activityDataSource: true,
        },
    },
}); };
//# sourceMappingURL=EmissionFactor.js.map